import React from "react";

// Filtros de la pantalla de Cartera Banco Solidario. Markup y clases tomadas
// directamente del mockup de Stitch (grid-cols-12, inputs planos, botón
// "Buscar" en el azul de marca #2d367f) — no MUI acá, para calzar pixel a
// pixel con el diseño aprobado.
export function FiltrosCarteraBS({
  fechaInicio, setFechaInicio,
  fechaFin, setFechaFin,
  filtro, setFiltro,
  lote, setLote,
  numeroUltimoLote,
  handleConsultar, loadingConsulta,
}) {
  const inputClass =
    "w-full border border-gray-300 rounded-md text-sm px-3 py-2 focus:ring-2 focus:ring-[#01BEDE] focus:border-[#01BEDE] outline-none transition-colors";

  return (
    <div className="grid grid-cols-12 gap-4 items-end mb-8">
      <div className="col-span-6 md:col-span-2">
        <label className="block text-xs font-semibold text-gray-500 mb-1">Desde</label>
        <input
          type="date"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <label className="block text-xs font-semibold text-gray-500 mb-1">Hasta</label>
        <input
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="col-span-12 md:col-span-3">
        <label className="block text-xs font-semibold text-gray-500 mb-1">Cliente</label>
        <input
          type="text"
          placeholder="Cliente"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleConsultar(); }}
          className={inputClass}
        />
      </div>
      <div className="col-span-6 md:col-span-1">
        <label className="block text-xs font-semibold text-gray-500 mb-1">N. Lote</label>
        <input
          type="number"
          value={lote}
          onChange={(e) => setLote(e.target.value)}
          className={inputClass}
        />
      </div>
      <div className="col-span-6 md:col-span-1">
        <label className="block text-xs font-semibold text-gray-500 mb-1">N. Último Lote</label>
        <input
          type="number"
          value={numeroUltimoLote ?? 0}
          disabled
          className={`${inputClass} bg-gray-50 text-gray-500`}
        />
      </div>
      <div className="col-span-12 md:col-span-3 md:text-right">
        <button
          onClick={handleConsultar}
          disabled={loadingConsulta}
          className="w-full md:w-auto bg-[#2d367f] text-white px-8 py-2 rounded shadow-md font-bold hover:bg-opacity-90 transition disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loadingConsulta ? "Buscando..." : "Buscar"}
        </button>
      </div>
    </div>
  );
}
